import { FC, useEffect, useState } from 'react';
import { JobStatus } from '../constant';
import { RadioWithLabel } from 'components';
import { getAvailableJobStatuses, getJobStatusColor } from '../utils';
import ChevronArrowRightReactIcon from 'assets/react-icons/ChevronArrowRightReactIcon';
import CustomModal from 'components/custom-modal/CustomModal';
import { CircleCloseIcon } from 'assets/icons';
import { WebAppColors } from 'constants/colors';
import { useAppSelector } from 'hooks/typedHooks';
import { selectCurrentTeamJobPermissions, selectMerchantCustomizations } from 'containers/app/appSlice';

interface EditStatusModalProps {
  status: JobStatus;
  onBackClick: () => void;
  handleStatusChange: (jobStatus: JobStatus) => void;
  jobNumber: string;
}

const EditStatusModal: FC<EditStatusModalProps> = ({ status, onBackClick, handleStatusChange, jobNumber }) => {
  const jobPermissions = useAppSelector(selectCurrentTeamJobPermissions);
  const { teamConfigs } = useAppSelector(selectMerchantCustomizations);
  const [jobStatusList, setJobStatusList] = useState([]);

  useEffect(() => {
    const availableStatuses = getAvailableJobStatuses(status, jobPermissions, teamConfigs);
    setJobStatusList(availableStatuses);
  }, [status, jobPermissions, teamConfigs]);

  return (
    <CustomModal open={true} closeModal={onBackClick} width="md:w-[510px]">
      <div className="h-full px-[30px] py-6">
        <div className="relative mb-6 flex items-center">
          <div className="flex flex-col text-headingGray">
            <span className="text-17px font-bold">Edit job status</span>
            <span className="mt-1 text-sbase font-semibold">{jobNumber}</span>
          </div>
          <CircleCloseIcon className="absolute right-0 top-0 cursor-pointer" onClick={onBackClick} />
        </div>
        <div>
          {jobStatusList.map((jobStatus, index) => (
            <div
              key={jobStatus.value}
              className={`flex items-center justify-between py-5 px-4 ${
                index !== jobStatusList.length - 1 ? 'border-b border-secondaryBtn' : ''
              }`}
              onClick={() => handleStatusChange(jobStatus.value)}>
              <RadioWithLabel
                isSelected={jobStatus.value === status}
                label={jobStatus.label}
                onClick={() => null}
                labelStyle={{ color: getJobStatusColor(jobStatus.value), fontWeight: '600', fontSize: '15px' }}
              />
              {jobStatus.value !== status && (
                <ChevronArrowRightReactIcon id={`edit-status-panel-${jobStatus.value}`} fill={WebAppColors.Gray_1} />
              )}
            </div>
          ))}
        </div>
      </div>
    </CustomModal>
  );
};

export default EditStatusModal;
